"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const dateformat_1 = require("../../../common/js/helper/dateformat");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const LocalStorageKeys_1 = __importDefault(require("../../enums/LocalStorageKeys"));
const MachineStore_1 = __importDefault(require("../../stores/MachineStore"));
const TableTile_1 = __importDefault(require("../TableTile"));
const AssetsCutterTableExpandedItem_1 = __importDefault(require("./AssetsCutterTableExpandedItem"));
class AssetsCutter extends react_1.default.Component {
    columns = [
        {
            allowOverflow: true,
            name: (0, translation_1.t)('myassets.cutter.table.product.column_name'),
            selector: (cutter) => cutter.name,
            sortable: true,
            minWidth: '28.125rem',
        },
        {
            allowOverflow: true,
            name: (0, translation_1.t)('myassets.cutter.table.product_sn.column_name'),
            selector: (cutter) => cutter.externalId,
            sortable: true,
            minWidth: '17.5rem',
        },
        {
            allowOverflow: true,
            name: (0, translation_1.t)('myassets.cutter.table.install_date.column_name'),
            selector: (cutter) => cutter.installationDate?.valueOf() ?? 0,
            format: (cutter) => (0, dateformat_1.getDateFormat)(cutter.installationDate) ?? '',
            sortable: true,
            minWidth: '11.25rem',
        },
        {
            allowOverflow: true,
            name: (0, translation_1.t)('myassets.cutter.table.status.column_name'),
            selector: (cutter) => cutter.warrantyState,
            sortable: true,
            format: (cutter) => (0, translation_1.t)('cutters.warranty_state.enum', {
                state: cutter.warrantyState,
            }),
            minWidth: '11.25rem',
        },
        {
            allowOverflow: true,
            name: (0, translation_1.t)('myassets.cutter.table.end_of_guarantee.column_name'),
            selector: (cutter) => cutter.warrantyEndDate?.valueOf() ?? 0,
            format: (cutter) => (0, dateformat_1.getDateFormat)(cutter.warrantyEndDate) ?? '',
            sortable: true,
            minWidth: '25rem',
        },
    ];
    contextReactionDisposer;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            cutterId: mobx_1.computed,
        });
    }
    get cutterId() {
        return this.props.match.params.cutterId ?? '';
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('myassets_subpage_title', { title: (0, translation_1.t)('myassets.cutter.title') });
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.customerId, () => MachineStore_1.default.readMassiveMachines(), { fireImmediately: true });
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
    }
    render() {
        if (MachineStore_1.default.isLoading) {
            return (react_1.default.createElement("section", { className: "znd-asset" },
                react_1.default.createElement(LoadingSpinner_1.default, { center: true })));
        }
        return (react_1.default.createElement("section", { className: "znd-asset" },
            react_1.default.createElement(TableTile_1.default, { columns: this.columns, data: MachineStore_1.default.cutters, title: (0, translation_1.t)('myassets.cutter.title'), expandableComponent: AssetsCutterTableExpandedItem_1.default, localStorageKey: LocalStorageKeys_1.default.cutterSort, onExpandedRow: (row) => row.id === this.cutterId, scrollInside: true })));
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(AssetsCutter));
